
$('.elevate').click(function() {
    $('html,body').animate({ scrollTop: 0 },650,'easeInOutExpo');
});


